import { render, staticRenderFns } from "./Safe2Pay.vue?vue&type=template&id=0338505f&"
import script from "./Safe2Pay.vue?vue&type=script&lang=js&"
export * from "./Safe2Pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports